export default function initVideoSlider() {
  Alpine.data('videoSlider', () => ({
    currentSlide: 0,
    slideWidth: 0,
    slides: [] as HTMLElement[],
    isDragging: false,
    startX: 0,
    currentTranslate: 0,
    prevTranslate: 0,
    startTouchX: 0,
    dragHandler: (event: MouseEvent) => {},

    init() {
      this.slides = Array.from(this.$refs.sliderWrapper.querySelectorAll('.video-slider'));
      this.$watch('currentSlide', () => {
        if (this.currentSlide === 0) {
          this.$refs.prevButton.setAttribute('disabled', 'true');
          this.$refs.nextButton.removeAttribute('disabled');
        }

        if (this.currentSlide > 0 && this.currentSlide < this.slides.length - 1) {
          this.$refs.prevButton.removeAttribute('disabled');
          this.$refs.nextButton.removeAttribute('disabled');
        }

        if (this.currentSlide === this.slides.length - 1) {
          this.$refs.prevButton.removeAttribute('disabled');
          this.$refs.nextButton.setAttribute('disabled', 'true');
        }

        Array.from(this.$refs.sliderDots.children).forEach((dot: Element, index: number) => {
          if (index === this.currentSlide) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });
        this.$refs.sliderWrapper.style.transform = `translate3d(-${this.slideWidth * (this.currentSlide)}px, 0px, 0px)`;

        this.slides.forEach((slide: HTMLElement, index: number) => {
          const videoButton = slide.querySelector('.video-button');
          const buttons = slide.querySelectorAll('button, a');
          if (videoButton) {
            if (index === this.currentSlide) {
              videoButton.removeAttribute('tabindex');
            } else {
              videoButton.setAttribute('tabindex', '-1');
            }
          }
          if (buttons.length > 0) {
            buttons.forEach((button: Element) => {
              if (index === this.currentSlide) {
                button.removeAttribute('tabindex');
              } else {
                button.setAttribute('tabindex', '-1');
              }
            });
          }
        });
      });

      const updateSlideWidth = () => {
        this.slideWidth = this.slides[0] ? (parseInt(getComputedStyle(this.slides[0]).marginRight)) + this.slides[0].offsetWidth : 0;
      };

      updateSlideWidth();
      window.addEventListener('resize', updateSlideWidth);

      this.$refs.sliderWrapper.addEventListener('touchstart', this.startSwipe.bind(this));
      this.$refs.sliderWrapper.addEventListener('touchmove', this.swipe.bind(this));
      this.$refs.sliderWrapper.addEventListener('touchend', this.endSwipe.bind(this));

      this.dragHandler = this.drag.bind(this);
      this.$refs.sliderWrapper.addEventListener('mousedown', this.startDrag.bind(this));
      this.$refs.sliderWrapper.addEventListener('mouseup', this.endDrag.bind(this));
      this.$refs.sliderWrapper.addEventListener('mouseleave', this.endDrag.bind(this));
    },

    startSwipe(event: TouchEvent) {
      this.isDragging = true;
      this.startTouchX = event.touches[0].clientX;
      this.prevTranslate = this.currentTranslate;
    },

    swipe(event: TouchEvent) {
      if (!this.isDragging) return;
      const currentTouchX = event.touches[0].clientX;
      const deltaX = currentTouchX - this.startTouchX;
      this.currentTranslate = this.prevTranslate + deltaX;
      this.$refs.sliderWrapper.style.transform = `translate3d(${this.currentTranslate}px, 0px, 0px)`;
    },

    endSwipe() {
      this.isDragging = false;
      const movedBy = this.currentTranslate - this.prevTranslate;
      if (movedBy < -this.slideWidth / 2 && this.currentSlide < this.slides.length - 1) {
        this.nextSlide();
      } else if (movedBy > this.slideWidth / 2 && this.currentSlide > 0) {
        this.prevSlide();
      }
    },

    startDrag(event: MouseEvent) {
      event.preventDefault();
      this.isDragging = true;
      this.startX = event.clientX;
      this.prevTranslate = this.currentTranslate;
      this.$refs.sliderWrapper.addEventListener('mousemove', this.dragHandler);
    },

    drag(event: MouseEvent) {
      if (!this.isDragging) return;
      event.preventDefault();
      const currentX = event.clientX;
      const deltaX = currentX - this.startX;
      this.currentTranslate = this.prevTranslate + deltaX;

      // Constrain the dragging logic to prevent excessive movement
      if (this.currentSlide === 0 && this.currentTranslate > 0) {
        this.currentTranslate = 0;
      } else if (this.currentSlide === this.slides.length - 1 && this.currentTranslate < -this.slideWidth * (this.slides.length - 1)) {
        this.currentTranslate = -this.slideWidth * (this.slides.length - 1);
      }

      this.$refs.sliderWrapper.style.transform = `translate3d(${this.currentTranslate}px, 0px, 0px)`;
    },

    endDrag() {
      if (!this.isDragging) return;
      this.isDragging = false;
      const movedBy = this.currentTranslate - this.prevTranslate;
      const previousSlide = this.currentSlide;

      if (movedBy < -this.slideWidth / 2 && this.currentSlide < this.slides.length - 1) {
        this.nextSlide();
      } else if (movedBy > this.slideWidth / 2 && this.currentSlide > 0) {
        this.prevSlide();
      }

      if (previousSlide === this.currentSlide) {
        // If no slide change, snap back to current position
        this.$refs.sliderWrapper.style.transform = `translate3d(-${this.slideWidth * this.currentSlide}px, 0px, 0px)`;
      }

      this.$refs.sliderWrapper.removeEventListener('mousemove', this.dragHandler);
    },

    nextSlide() {
      this.currentSlide = Math.min(this.currentSlide + 1, this.slides.length - 1);
    },

    prevSlide() {
      this.currentSlide = Math.max(this.currentSlide - 1, 0);
    },

    updateActiveSlide() {
      const dot = this.$el;
      this.currentSlide = parseInt(dot.dataset.slideIndex || '0');
    },
  }));
}